import React from 'react';
import PropTypes from 'prop-types';
import StyledAssignButton from './styled/assignButton';
export default function ModifyCell(props) {
  var _onClick = props.onClick,
      value = props.value,
      row = props.row;
  var buttonText = value ? 'Change' : 'Assign';
  return React.createElement(StyledAssignButton, {
    onClick: function onClick() {
      return _onClick(row.databaseField);
    }
  }, buttonText);
}
ModifyCell.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
  row: PropTypes.object.isRequired
};
ModifyCell.defaultProps = {
  onClick: function onClick() {},
  value: ''
};